import * as backend from '@/api/backend';

export default {
  namespaced: true,
  state: {
    templates: [],
  },
  mutations: {
    SET_TEMPLATES(state, templates) {
      state.templates = Array.isArray(templates) ? templates : [];
    },
  },
  actions: {
    async fetchTemplates({ commit }) {
      const response = await backend.getDealImagePromptTemplates();
      commit('SET_TEMPLATES', response.data || []);
      return response.data;
    },
    async createTemplate(_, { template }) {
      const response = await backend.postDealImagePromptTemplate(template);
      return response.data;
    },
    async updateTemplate(_, { templateId, template }) {
      const response = await backend.putDealImagePromptTemplate(templateId, template);
      return response.data;
    },
    async deleteTemplate(_, { templateId }) {
      await backend.deleteDealImagePromptTemplate(templateId);
    },
  },
};
